/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Languagedescription2Inputs */

const zh_systemsettings_languagedescription2 = /** @type {(inputs: Systemsettings_Languagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择界面显示语言。`)
};

const en_systemsettings_languagedescription2 = /** @type {(inputs: Systemsettings_Languagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the interface language.`)
};

const es_systemsettings_languagedescription2 = /** @type {(inputs: Systemsettings_Languagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige el idioma de la interfaz.`)
};

/**
* | output |
* | --- |
* | "Choose the interface language." |
*
* @param {Systemsettings_Languagedescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_languagedescription2 = /** @type {((inputs?: Systemsettings_Languagedescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Languagedescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_languagedescription2(inputs)
	if (locale === "en") return en_systemsettings_languagedescription2(inputs)
	return es_systemsettings_languagedescription2(inputs)
});
export { systemsettings_languagedescription2 as "systemSettings_languageDescription" }